import InternalLinkMod from './InternalLinkMod';

export default function InternalLinkModule({ links = {} }) {
  const { popularMakesModels = {}, ...otherLinkTypes } = links;

  return Object.keys(links).length > 0 ? (
    <>
      {popularMakesModels.links?.length > 0 && (
        <InternalLinkMod linksData={popularMakesModels} minLinks={9} />
      )}
      {Object.values(otherLinkTypes)
        .filter(Boolean)
        .map(linkData => (
          <InternalLinkMod
            key={linkData.title}
            linksData={linkData}
            minLinks={9}
          />
        ))}
    </>
  ) : null;
}
